import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/search-engine/engine_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">
                Search Engine Marketing Services
              </h1>
              <span>Responsive Search Ads for Wider Reach & Higher CTR</span>
              <p>
                Get found by millions of potential prospects with custom,
                high-impact search ads. We plan, execute, and scale
                funnel-optimized ad campaigns for custom audiences. Our search
                engine marketing services help businesses rank above the fold,
                generate instant traffic, and drive conversion rate lift.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start with a Free Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
